export const enableTooltipButtons = () => {
  const tooltipButtons = document.querySelectorAll('[data-tooltip-trigger]');

  tooltipButtons?.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      closeTooltipButtons();
      if (e.target.closest('[data-tooltip-trigger]') && !e.target.closest('[data-target="close-tooltip"]')) {
        button.classList.add('tooltip-active');
        const closeButton = button.querySelector('[data-target="close-tooltip"]');
        if (closeButton) {
          closeButton.addEventListener('click', () => {
            button.classList.remove('tooltip-active');
          });
        }
      }
    });
  });

  if (tooltipButtons) {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-tooltip-trigger]')) {
        closeTooltipButtons();
      }
    });
  }
};

export const closeTooltipButtons = () => {
  const tooltipButtons = document.querySelectorAll('[data-tooltip-trigger]');
  tooltipButtons?.forEach((button) => {
    button.classList.remove('tooltip-active');
  });
};
